import React from "react";
import { Link } from "react-router";
import { ReactSVG } from "react-svg";
import "./StudentSidebarNav.css";

/**
 * Student dashboard tab list. Rendered inline on desktop and inside the mobile
 * sidebar drawer, so both stay in sync.
 */
const StudentSidebarNav = ({ tabList, activeTab, setActiveTab }) => (
  <div className="studentDashboardSidePannel">
    {tabList.map((tab, index) => {
      const isActive = activeTab === tab.key || activeTab === tab.route;

      return (
        <Link
          key={index}
          to={`/dashboard/${tab.route.toLowerCase()}`}
          onClick={() => setActiveTab(tab.key)}
          className={(isActive ? "active" : "") + " dashboardlink"}
        >
          <ReactSVG
            src={isActive ? (tab.activeValue ?? tab.value) : tab.value}
            className={isActive ? "svg-active" : "svg-inactive"}
          />
          <span className="dashboardlink-label">{tab.key}</span>
        </Link>
      );
    })}
  </div>
);

export default StudentSidebarNav;
